import React from "react";
import { createUseStyles } from "react-jss";
import { GridHelper } from "./GridHelper/GridHelper";
import { StickyBlockContainer } from "../Container/StickyBlockContainer";
import { SectionGridSize } from "../helpers/enums";
import { Scroller, Step } from "../Scroller";
import { useScrollytellState } from "../Admin/scrollytellContext";
import { Blocks } from "../Block/Blocks";
import { MapScroll } from "../map/MapScroll";
import { MapContainer } from "../background/MapContainer";
import { useContentHeight } from "../map/useContentHeight";
import {
  nineColumnsGrid,
  twelveColumnsGrid,
  thumbnailGrid,
} from "./sectionGridStyles";
import { computeMapSectionMultiplier } from "../map/mapWaypoints";

const useStyles = createUseStyles({
  grid: {
    top: 0,
    position: "relative",
    minHeight: ({ minHeight }) => minHeight,
    height: ({ height }) => height,
    display: "grid",
    zIndex: 10,
  },
  thumbnail: thumbnailGrid,
  nineColumns: nineColumnsGrid,
  twelveColumns: twelveColumnsGrid,
});

export const StickyMapSection = ({
  sectionId,
  isAdminMode,
  section,
  isThumbnail,
}) => {
  const {
    backgroundColor,
    height,
    containers = [],
    gridSize = SectionGridSize.NINE_COLUMNS,
  } = section;
  const [activeStepIndex, setActiveStepIndex] = React.useState(0);
  const { showGrid } = useScrollytellState();
  const contentHeight = useContentHeight();
  const multiplier = computeMapSectionMultiplier(containers.length);
  const classes = useStyles({
    height,
    minHeight: `${multiplier * contentHeight}px`,
    gridSize,
  });

  const handleStepEnter = ({ data }) => {
    if (data && typeof data.i === "number") {
      setActiveStepIndex(data.i);
    }
  };

  return (
    <>
      {showGrid && isAdminMode && (
        <GridHelper
          sectionId={sectionId}
          gridSize={gridSize}
          backgroundColor={backgroundColor}
        />
      )}
      <article
        className={`${classes.grid} ${classes[gridSize]} ${
          isThumbnail ? classes.thumbnail : ""
        }`}
      >
        <Scroller
          section={section}
          containersCount={containers.length}
          isThumbnail={isThumbnail}
          offset={0.9}
          contentHeight={contentHeight}
          isMap={true}
          onStepEnter={handleStepEnter}
        >
          {containers
            ?.slice(0, isThumbnail ? 1 : containers?.length)
            .map((container, i) => (
              <Step data={{ container, i }} key={i}>
                <StickyBlockContainer
                  key={`container-${i}`}
                  sectionId={sectionId}
                  containerId={i}
                  isAdminMode={isAdminMode}
                  container={container}
                  gridSize={gridSize}
                  hasBlocks={Boolean(container.blocks?.length)}
                  isMapCard={true}
                  isThumbnail={isThumbnail}
                >
                  <Blocks
                    sectionId={sectionId}
                    containerId={i}
                    isAdminMode={isAdminMode}
                    blocks={container.blocks}
                  />
                </StickyBlockContainer>
              </Step>
            ))}
        </Scroller>
      </article>
      <MapContainer>
        <MapScroll
          containersCount={containers.length}
          zoom={section.zoom}
          sectionId={sectionId}
          contentHeight={contentHeight}
          isThumbnail={isThumbnail}
          activeStepIndex={activeStepIndex}
        />
      </MapContainer>
    </>
  );
};
